import { isDefined } from "./functions";

export const isWholeThousand = (value: number | undefined): value is number =>
  isDefined(value) && value % 1000 === 0;

export const getLimitWithinRange = (
  value: number,
  min: number,
  max: number,
): number => Math.max(min, Math.min(max, value));
